import { VisitDetailPhotos } from '@types-lib';

export const photoStoreInitialState: VisitDetailPhotos.VisitDetailPhotoState = {
  examPhotos: [],
  diagnosis: null,
  loadingAiDermMap: {}
};

